export default __webpack_public_path__ + "static/media/notepad2.e567a334.svg";